import { render } from "./fingerPrintAth.vue?vue&type=template&id=6fe2fda7"
import script from "./fingerPrintAth.vue?vue&type=script&lang=js"
export * from "./fingerPrintAth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__